export default __webpack_public_path__ + "roboto-bold-webfont.woff";